import { Owner } from 'cargo-chief-commons';

export const bookingAssistantAutomationPageStateKey = 'booking-assistant-automation-page';

export interface EmailRoutingData {
	type: 'region' | 'revenueCode' | 'salesRep' | 'orderTypeId' | 'assignedUser';
	list: {
		user: { name: string; email: string };
		state?: string;
		salesRepId?: string;
		revenueCode?: string;
	}[];
}

export interface BookingAssistantAutomationState {
	enabledIntegration: any;
	enabledIntegrationDataFields: any;
	bookingAssistantDataFields: any;
	error: string;
	loading: boolean;
	bookNowData: Array<Object>;
	emailRoutingData: EmailRoutingData;
	activeUsersList: Owner[];
	dispatchUserData: {
		current: Owner;
		updated: Owner;
	};
}

export const initialState: BookingAssistantAutomationState = {
	enabledIntegration: null,
	enabledIntegrationDataFields: '',
	bookingAssistantDataFields: '',
	error: null,
	loading: true,
	bookNowData: [],
	emailRoutingData: { type: null, list: [] },
	activeUsersList: [],
	dispatchUserData: { current: null, updated: null },
};
